import React from 'react'
import Suppliers from './Suppliers';
import BreadCrumb from './BreadCrumb';

function SupplierPage() {
    return ( 
        <div className = "container-fluid">
        <BreadCrumb />
        <Suppliers />
        </div>
     );
}

export default SupplierPage;